import { FaStore } from "react-icons/fa"; // Bạn có thể đổi icon khác nếu muốn
import "./SessionProducts.css";

const productsData = [
  {
    id: "cong-cu-dung-cu",
    title: "Công Cụ – Dụng Cụ",
    image: "/images/home/products/product1.webp",
  },
  {
    id: "nguyen-vat-lieu",
    title: "Nguyên Vật Liệu",
    image: "/images/home/products/product2.webp",
  },
  {
    id: "thiet-bi-may-moc",
    title: "Thiết Bị – Máy Móc",
    image: "/images/home/products/product3.webp",
  },
];

const SessionProducts = () => (
  <section className="products">
    <div className="products__container">
      {/* Icon */}
      <div className="products__icon">
        <FaStore />
      </div>

      {/* Title */}
      <h2 className="products__title">Cửa hàng</h2>

      {/* 3 Cards ngang */}
      <div className="products__cards">
        {productsData.map(({ id, title, image }) => (
          <div
            key={id}
            className="products__card"
          >
            {/* Wrapper ảnh riêng */}
            <div className="products__card-image-wrapper">
              <img
                src={image}
                alt={title}
                className="products__card-image"
                loading="lazy"
              />
            </div>

            {/* Wrapper tiêu đề riêng */}
            <div className="products__card-text-wrapper">
              <h3 className="products__card-title">{title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SessionProducts;
